export default (event, shareKey, withLabel, modal, canDownload, canFavorite = false) => ({
    event,
    tab: 0,
    shareKey,
    withLabel,
    canDownload,
    canFavorite,
    images: [],
    open: !modal,
    eventId: null,
    imagesCount: 0,
    downloading: [],
    favoriteCount: 0,

    init() {
        if (!this.canFavorite) {
            return;
        }

        window.addEventListener('customerImages::sync-failed', () => {
            this.$dispatch(`${this.event}::restart`, {
                params: { favorite: this.tab === 1 ? 1 : null }
            });
        });
    },

    getLabel({event_name, event_date}) {
        return `(${event_date}) ${event_name}`;
    },

    loadedImages($data) {
        this.imagesCount   = $data.totalRowsCount;
        this.favoriteCount = $data.favoriteRows;
        this.images = $data.items;
    },

    favoriteTab() {
        this.tab = 1;
        this.$dispatch(`${this.event}::restart`, {
            params: { favorite: 1 }
        });
    },

    allTab() {
        this.tab = 0;
        this.$dispatch(`${this.event}::restart`, {
            params: { favorite: null }
        });
    },

    async download(event){
        const image = _.get(event, 'detail');
        const name = _.get(image, 'name');

        if (this.$isMobileSafari()) {
            this.$dispatch('view-photo-modal::open', image);

            this.downloading = this.downloading.filter(
                (downloaded) => downloaded !== name
            );

            this.$dispatch(`${this.event}::refresh`)

            return;
        }

        this.downloading.push(name);

        this.$downloadImage(image.high_res, name, () => {
            this.downloading = this.downloading.filter(
                (downloaded) => downloaded !== name
            );

            this.$dispatch(`${this.event}::refresh`)
        });
    },

    openSliderPreview(event) {
        const imageId = _.get(event, 'detail.id');

        this.$dispatch('open::slider-preview', [
            this.images,
            this.images.findIndex(image => image.id == imageId),
            {
                canDownload: this.canDownload,
                canFavorite: this.canFavorite,
                canSave: false,
                event: `${this.event}::toggle`,
                mainEventId: this.shareKey,
                scrollTarget: this.event,
                totalImagesCount: this.imagesCount
            }
        ]);
    },

    favorite(event) {
        if (!this.canFavorite) {
            return;
        }

        const image = _.get(event, 'detail', {});

        this.$store.customerImages.toggleFavoriteImage(image, this.shareKey);

        this.applyFavoriteChange(image);
    },

    toggleImage(event) {
        if (!this.canFavorite) {
            return;
        }

        const image  = _.get(event, 'detail.image', {});
        const action = _.get(event, 'detail.action');

        if (action !== 'favorite') {
            return;
        }

        this.applyFavoriteChange(image);
    },

    applyFavoriteChange(image) {
        this.favoriteCount = Math.max(0, this.favoriteCount + (image.favorite ? 1 : -1));

        this.$dispatch(`${this.event}::hide-preview`);

        if (!_.find(this.images, { id: image.id })) {
            return;
        }

        this.$dispatch(`${this.event}::refresh`, { image });
    },

    share() {
        this.$wire.share(this.eventId ?? this.shareKey);
    },

    openModal({ eventId = null, mainEventId = null }) {
        if(eventId !== this.eventId || (mainEventId !== null && mainEventId !== this.shareKey) ) {
            this.shareKey = mainEventId ?? this.shareKey;

            this.$dispatch(`${event}::restart`, {
                params: { eventId, mainEventId: this.shareKey }
            });

            this.eventId = eventId;
        }

        this.open = true;
        this.withLabel = this.eventId === null;
    }
});
